import React from 'react';
import 'react-native-match-media-polyfill';
import 'resize-observer-polyfill/dist/ResizeObserver.global';

import Provider from './Provider';
import BreakpointDebug from './components/BreakpointDebug';
import Navigation from './navigation';

export const App = () => {
  return (
    <Provider>
      <Navigation />
      {process.env.REACT_APP_DEBUG_BREAKPOINTS && <BreakpointDebug />}
    </Provider>
  );
};
export default App;
